// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__28XsU","paramInput":"JobSimulator_paramInput__3iCRb","input":"JobSimulator_input__3jouS"};